<template>
  <transition name="zoom-out">
    <div class="v-cal-dialog" v-if="isActive">
      <div class="v-cal-dialog__bg" @click="cancel"></div>
      <div class="v-cal-dialog-card">
        <form @submit.prevent="saveEvent">
          <header class="v-cal-dialog-card__header">
            <h5 class="v-cal-dialog__title">Please select time and reason</h5>
<!--            <h5 class="v-cal-dialog__title">{{ title }}</h5>-->
            <button
              type="button"
              class="v-cal-dialog__close"
              @click="cancel"
            ></button>
          </header>
          <section class="v-cal-dialog-card__body">
            <div class="v-cal-fields">


                <template v-for="(field, index) in fields">
                <event-dialog-input
                  v-model="event[field.name]"
                  :key="field.name + '-' + index"
                  :field="field"
                  v-if="!field.fields"
                />

                  <div class="v-cal-input-group" :key="field.name" v-else>
<!--                  <label v-if="field.label">{{ field.label }}</label>-->
<!--                  <event-dialog-input-->
<!--                          :idx="index"-->
<!--                    v-model="event[subfield.name]"-->
<!--                    :key="subfield.name + '-' + index"-->
<!--                    :field="subfield"-->
<!--                    v-for="(subfield, index) in field.fields"-->
<!--                  />-->

                    <div class="input-flex-wrapper">
                        <div><span>{{ startTime === null ? event.startTime.format('HH:mm'): startTime}}</span></div>
                        <div class="form-group" >
                            <!--                <label for="sel1">Select list:</label>-->
                            <select class="form-control" @change="onChange($event)">
                                <option>15</option>
                                <option>30</option>
                                <option>45</option>
                            </select>
                        </div>
                        <div><span>{{ endTime === null ? event.endTime.format('HH:mm'): endTime }}</span></div>
                      <div><span>{{showDate}} {{ getWeekDayNameForSc(showDate) }}</span></div>

                    </div>
                      <div class="sc-reasons">

                          <div>
                            <span v-if="scheduledCallReason === ' Reasons :'" class="dot"></span>
                            <p class="for-res" @click="openReasons = !openReasons" >{{scheduledCallReason !== ' Reasons :'? ' Reason : '  : scheduledCallReason}}  <span v-if="scheduledCallReason === ' Reasons :'" class="add-reasons"> ADD</span><span   v-tooltip="{ content: scheduledCallReason.type }" class="res-it-self" v-else>{{scheduledCallReason.type |  truncate(20) }}</span></p>
                                   <ul v-if="openReasons" class="lang-dropdown">
                                  <li
                                          @click="
                [
                  (openReasons = false),
                  (scheduledCallReason = item),
                  (scheduledCallStatusReason = item.type),
                ]
              "
                                          class="add-tag-menu-item"
                                          v-for="item in scReasons"
                                          :key="item"
                                          :class="{
                'selected-reason':
                  scheduledCallReason !== ' Reasons :'
                    ?scheduledCallReason === item
                    : false
              }"
                                  >
                                      {{ item.type }}
                                  </li>
                              </ul>
                          </div>
                        <div v-if="openReasons == false">
                          <div

                              class="qs-warning"
                          >
                            <span class="haj"></span>
                          </div>

                          <div v-for="(id, idx) in questLog" :key="id.id">

                            <div

                                class="dep-qs-form"
                                :class="{ 'dep-qs-form-even': idx % 2 === 0 }"
                            >

                                <span
                                    class="quest-line-bold"
                                    :class="{ 'dep-qs-form-even': idx % 2 === 0 }"
                                >
                            {{ id.question }}
                                </span>
                              <div class="quest-inline">
                                <client-answer-for-sc
                                    :key="answKey"
                                    :for-sc="true"
                                    :client="clientObj"
                                    :question-id="id.id"
                                    :clientAnswerOpt = clientAnswerOpt
                                    @updated="fetchClients"
                                ></client-answer-for-sc>
                              </div>
                            </div>
                          </div>
                        </div>
                          <textarea
                                  class="form-control input-sm comment-box-scheduled "
                                  placeholder="Comment"
                                  v-model.trim="scheduledCallComment"
                                  maxlength="160"
                          ></textarea>
                          <span class="text-counter-scheduled"
                          >{{ scheduledCallComment.length }}/160</span
                          >
                          <p v-if="scheduledCallCommentError.length > 0" class="help-block">
                              {{ scheduledCallCommentError }}
                          </p>
                      </div>


                </div>
              </template>
            </div>
          </section>
          <footer class="v-cal-dialog-card__footer">
<!--            v-tooltip="{ content: `Please Choose Reasons`,show:scheduledCallReason === ' Reasons :',trigger:'manual' }"-->

            <button :disabled="scheduledCallReason === ' Reasons :' && showTool" type="submit" class="v-cal-button is-rounded is-primary"
                    @mouseenter="showTool = true"
                    @mouseleave="showTool = false"
            >
              {{ createButtonLabel }}
            </button>
            <span class="forTool" v-if="showTool && scheduledCallReason === ' Reasons :'"   >
Please Choose Reasons
            </span>
          </footer>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import Event from "../../model/Event";
import moment from "moment";
import EventDialogInput from "./EventDialogInput";
import { mapGetters, mapState } from "vuex";
import ClientAnswerForSc from "../../../../../../../clients_table.sub_feature.company/components/questioner/ClientAnswerForSc.component";

import apiClientCreator from "@/helpers/api/request";
import ClientModel
  from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/ClientModel";


export default {
  components: { EventDialogInput, ClientAnswerForSc },

  props: {
    title: String,
    inputClass: String,
    overrideInputClass: Boolean,
    fields: Array,
    createButtonLabel: String,
      scReasons:{
        type: Array
      },
    clientObj:{
      type: Object
    },
    clientAnswerOpt:{
      type: Object
    },
    showDate:{
      type: String
    },
    replaceClient:{
      type:Object,
      default(){
        return null;

      }
    }
    // store:{
    //   type:Object
    // }
  },
  data() {
    return {
      answKey: 0,
      isActive: false,
      event: {},
      startTime: null,
      endTime: null,
        scheduledCallComment: "",
        scheduledCallCommentError: "",
        scheduledCallReason: ' Reasons :',
      openReasons:false,
      questLog: [
        {
          id: 1,
          question: "Occupation"
        },
        {
          id: 2,
          question: "What Signals?"
        },
        {
          id: 3,
          question: "Trading Time"
        },
        {
          id: 4,
          question: "Invested So Far"
        },
        {
          id: 5,
          question: "How Much Profit Expected?"
        },
        {
          id: 6,
          question: "Plan To Invest?"
        },
        {
          id: 7,
          question: "Amount Of Broker Or Names"
        },
        {
          id: 8,
          question: "Amount Of Signals?"
        },
        {
          id: 9,
          question: "Reason for trading"
        },
        {
          id: 10,
          question: "Originaly From"
        },
        {
          id: 11,
          question: "Age"
        }
      ],
      pagination: {
        currentPage: 1,
        perPage: 5,
        from: 1,
        to: 1,
        lastPage: 1,
        total: 0
      },
      showTool:false

    };
  },
  computed: {
    ...mapState("clients", [
      "dictionaries",
    ])
  },

  beforeMount() {
    let plainEvent = {};
    this.fields.map(field => {
      if (!field.fields) plainEvent[field.name] = field.value;
      else {
        const fields = field.fields;
        fields.map(field => {
          if (field.type === "time") {
            plainEvent[field.name] = field.value
              ? moment(field.value, "HH:mm")
              : null;
          } else plainEvent[field.name] = field.value;
        });
      }
    });

    this.event = new Event(plainEvent);
    //  Insert the Dialog component in body tag
    document.body.appendChild(this.$el);
  },
  mounted() {
    this.isActive = true;
    this.event.startTime = moment(this.event.startTime)
    this.event.endTime = moment(this.event.startTime).add(15, 'minutes')
    //this.event.user = this.store.state.clients.auth.user
  },
  methods: {
    getWeekDayNameForSc(date) {
      return moment(date).format("ddd");
    },
    fetchClients(withStats) {
      // this.$store.commit("clients/setDebounceAll", false);

      this.selectedClientsFrom = [];
      this.sendUpdated = false;
      let path = "client/list";
      if (this.selectedMainTab === "affiliation") {
        path = "affiliation/client/click";
      }

      let apiClient = apiClientCreator(path);
      this.changeResesColor = true;
      // this.$store.commit("clients/setLoading", true);

      const queryParams = this.getQueryParams();
      // this.$store.commit("clients/setClientsDashBoardQueryParams", queryParams);
      this.getQueryParamsToMs = queryParams;
      this.resetMsAfterFilter = true;

      const clients = [];
      const filteredClients = [];
      this.filteredClientIds = [];

      apiClient
          .get("", { params: queryParams })
          .then(res => {
            this.changeResesColor = true;
            this.resetMsAfterFilter = false;

            if (this.selectedMainTab === "affiliation") {
              this.clickedClients = res.data.data;
            } else {
              res.data.data.forEach(function(data) {
                clients.push(new ClientModel(data));
              });
            }
            if (
                !withStats &&
                this.selectedMainTab !== "users" &&
                this.selectedMainTab !== "brokers"
            ) {
              if (!this.stopProcess) {
                this.updateStats();
              }
            }

            this.filteredClientIds = filteredClients;
            this.clients = clients;
            this.pagination.currentPage = res.data.current_page;
            this.pagination.perPage = res.data.per_page;
            this.pagination.from = res.data.from;
            this.pagination.to = res.data.to;
            this.pagination.lastPage = res.data.last_page;
            this.pagination.total = res.data.total;
            this.resetCalendars = false;
            this.resetMultiSelects = false;
            this.sendUpdated = true;
            this.changeResesColor = false;
            // this.$store.commit("clients/setLoading", false);

            if (this.filters.enlarge_leads) {
              // this.$store.commit("clients/setEnlargeCompanyTable", true);
            } else {
              // this.$store.commit("clients/setEnlargeCompanyTable", false);
            }

            return res;
          })
          .catch(e => {
            // this.$store.commit("main/setShowVikiMsg", {
            //   show: true,
            //   msg:
            //       "Connection Error!" + " " + " Error Status: " + e.response.status,
            //   type: "ERROR",
            //   op: { type: "SYSTEM" }
            // });

            // this.$store.commit("clients/setLoading", false);
          });
    },
    getQueryParams() {
      let vm = this;

      let queryParams = {
        page: vm.pagination.currentPage
        // order_by: vm.orderBy,
        // sort_order: vm.sortOrder
      };

      /** Add filters to query */
      for (let key in vm.filters) {
        if (!vm.filters.hasOwnProperty(key)) {
          continue;
        }

        if (key === "client") {
          queryParams = {
            ...queryParams,
            ...getClientQueryObject(vm.filters[key])
          };
        }

        if (vm.filters[key] === null || vm.filters[key] === false) {
          continue;
        }

        // add selectable filters to query

        if (key === "order_by" || key === "sort_order") {
          queryParams[key] = vm.filters[key];
        }

        if (key === "sms_status") {
          let slugs = [];
          // if (this.filters.click_on_site !== "Click Type") {
          vm.filters[key].forEach(function(item) {
            slugs.push(item.type);
          });
          //   }
          queryParams[key] = slugs;
        }
        if (
            key === "keywords" ||
            key === "aaids" ||
            key === "click_on_site" ||
            key === "placement" ||
            key === "device" ||
            key === "client_transfer_place"
        ) {
          let slugs = [];
          // if (this.filters.click_on_site !== "Click Type") {
          vm.filters[key].forEach(function(item) {
            slugs.push(item.id);
          });
          //   }
          queryParams[key] = slugs;
        }

        if (key === "loc_phys_ms") {
          let slugs = [];
          vm.filters[key].forEach(function(item) {
            slugs.push(item.id);
          });
          queryParams[key] = slugs;
        }

        // add searchable filters to query
        if (
            (key === "email" || key === "phone" || key === "last_ip") &&
            vm.filters[key].toString().length > 0
        ) {
          queryParams[key] = vm.filters[key];
        }

        if (
            key === "countries" ||
            key === "country_tiers" ||
            key === "referral_brokers" ||
            key === "referral_users" ||
            key === "country_parent" ||
            key === "assigned" ||
            key === "assigned_rank1" ||
            key === "assigned_rank2" ||
            key === "assigned_rank3" ||
            key === "assigned_by_rank" ||
            key === "orig_assigned" ||
            key === "group_assigned" ||
            key === "lead_campaigns" ||
            key === "lead_campaigns_users" ||
            key === "referral_campaigns_users" ||
            key === "referral_campaigns" ||
            key === "tier" ||
            key === "deposit_statuses" ||
            key === "deposit_brokers" ||
            key === "deposit_users" ||
            key === "deposit_sec_users" ||
            key === "deposit_lead_users" ||
            key === "deposit_answers" ||
            key === "deposit_brokers_quantity" ||
            key === "client_transfers" ||
            key === "client_transfers_type" ||
            key === "client_transfers_from" ||
            key === "client_transfers_by" ||
            key === "na_users" ||
            key === "ca_users" ||
            key === "priority" ||
            key === "ca_status" ||
            key === "ca_auto_status" ||
            key === "answers1" ||
            key === "answers2" ||
            key === "answers3" ||
            key === "answers4" ||
            key === "answers5" ||
            key === "answers6" ||
            key === "answers7" ||
            key === "answers8" ||
            key === "answers9" ||
            key === "answers10" ||
            key === "answers11" ||
            key === "answers_status" ||
            key === "sms_preset" ||
            key === "ni_status" ||
            key === "bn_status" ||
            key === "dup_users" ||
            key === "dup_na" ||
            key === "dup_ni" ||
            key === "dup_bn" ||
            key === "dup_na_ar"

            /*key === "click_on_site" ||
        key === "device"*/
        ) {
          let ids = [];

          vm.filters[key].forEach(function(item) {
            ids.push(item.id);
          });

          /*          if (ids.length > 0) {
            const filterToPush = this.filtersBarArr;
            const filtered = filterToPush.filter(item => item.key !== key);
            const filter_ = {
              text: key,
              stat: ids,
              key: key
            };
            this.filtersBarArr = [...filtered, filter_];
          }*/

          queryParams[key] = ids;
        }
        // if (key === "countries") {
        //   let ids = [];
        //   vm.filters[key].forEach(function(item) {
        //     ids.push(item.id);
        //   });
        //   queryParams[key] = ids;
        // }
        if (key === "registered_on" && vm.filters.registered_on) {
          queryParams.registered_on_from = moment(
              vm.filters["registered_on"][0]
          ).format("YYYY-MM-DD");
          queryParams.registered_on_to = moment(
              vm.filters["registered_on"][1]
          ).format("YYYY-MM-DD");
        }
        if (key === "scheduled_call_to" && vm.filters.scheduled_call_to) {
          queryParams.scheduled_call_to_from = moment(
              vm.filters["scheduled_call_to"][0]
          ).format("YYYY-MM-DD");
          queryParams.scheduled_call_to_to = moment(
              vm.filters["scheduled_call_to"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "deposit_at" && vm.filters.deposit_at) {
          queryParams.deposit_at_from = moment(
              vm.filters["deposit_at"][0]
          ).format("YYYY-MM-DD");
          queryParams.deposit_at_to = moment(
              vm.filters["deposit_at"][1]
          ).format("YYYY-MM-DD");
        }

        if (this.hoursCalsList.includes(key) && vm.filters[key]) {
          queryParams[`${key}_from`] = vm.filters[key][0];
          queryParams[`${key}_to`] = vm.filters[key][1];
        }

        if (key === "support_at" && vm.filters.support_at) {
          queryParams.support_at_from = moment(
              vm.filters["support_at"][0]
          ).format("YYYY-MM-DD");
          queryParams.support_at_to = moment(
              vm.filters["support_at"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified_na" && vm.filters.last_modified_na) {
          queryParams.last_modified_na_from = moment(
              vm.filters["last_modified_na"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_na_to = moment(
              vm.filters["last_modified_na"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified_leads" && vm.filters.last_modified_leads) {
          queryParams.last_modified_lead_from = moment(
              vm.filters["last_modified_leads"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_lead_to = moment(
              vm.filters["last_modified_leads"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_sc_tag" && vm.filters.last_sc_tag) {
          queryParams.last_sc_tag_from = moment(
              vm.filters["last_sc_tag"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_sc_tag_to = moment(
              vm.filters["last_sc_tag"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_modified" && vm.filters.last_modified) {
          queryParams.last_modified_from = moment(
              vm.filters["last_modified"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_to = moment(
              vm.filters["last_modified"][1]
          ).format("YYYY-MM-DD");
        }
        //  last_modified_personal

        if (
            key === "last_modified_personal" &&
            vm.filters.last_modified_personal
        ) {
          queryParams.last_modified_personal_from = moment(
              vm.filters["last_modified_personal"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_modified_personal_to = moment(
              vm.filters["last_modified_personal"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_transfer" && vm.filters.last_transfer) {
          queryParams.last_transfer_from = moment(
              vm.filters["last_transfer"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_transfer_to = moment(
              vm.filters["last_transfer"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "last_referral" && vm.filters.last_referral) {
          queryParams.last_referral_from = moment(
              vm.filters["last_referral"][0]
          ).format("YYYY-MM-DD");
          queryParams.last_referral_to = moment(
              vm.filters["last_referral"][1]
          ).format("YYYY-MM-DD");
        }

        if (key === "assigned_at" && vm.filters.assigned_at) {
          queryParams.assigned_at_from = moment(vm.filters[key][0]).format(
              "YYYY-MM-DD"
          );
          queryParams.assigned_at_to = moment(vm.filters[key][1]).format(
              "YYYY-MM-DD"
          );
        }
        if (key === "group_assigned_at" && vm.filters.group_assigned_at) {
          queryParams.group_assigned_at_from = moment(
              vm.filters[key][0]
          ).format("YYYY-MM-DD");
          queryParams.group_assigned_at_to = moment(vm.filters[key][1]).format(
              "YYYY-MM-DD"
          );
        }
        if (key === "scheduled_calls" && vm.filters[key] === true) {
          queryParams[key] = 1;
        }

        if (
            key === "enlarge_leads" ||
            key === "scheduled_calls" ||
            key === "missed_calls" ||
            key === "auto_missed_calls" ||
            key === "coming_calls" ||
            key === "today_calls" ||
            key === "is_new" ||
            key === "other_new" ||
            key === "selling_group" ||
            key === "leading_new" ||
            key === "loosing_new" ||
            key === "active" ||
            key === "is_leading" ||
            key === "online" ||
            key === "nac" ||
            key === "btgp" ||
            key === "auto_removal" ||
            key === "dup_source" ||
            key === "ex_dup_source" ||
            key === "dup_exclude" ||
            key === "merged" ||
            key === "tech" ||
            key === "dup" ||
            key === "reg_dup_total" ||
            key === "bad_number" ||
            key === "not_interested" ||
            key === "na" ||
            key === "na_all" ||
            key === "waiting" ||
            key === "ended" ||
            key === "referral" ||
            key === "transfer" ||
            key === "leads" ||
            key === "deposit" ||
            key === "deposit_clients" ||
            key === "cc_decline_clients" ||
            key === "show_country_stats" ||
            key === "fetch_camp_stats" ||
            key === "fetch_questions_stats" ||
            key === "sms_returned" ||
            key === "exclude_ca" ||
            key === "exclude_auto_ca" ||
            key === "exclude_na" ||
            key === "exclude_tr" ||
            key === "exclude_rf" ||
            key === "exclude_ld" ||
            key === "exclude_dp" ||
            key === "exclude_dp_filter" ||
            key === "deposit_to_rem" ||
            key === "deposit_from_cc" ||
            key === "recent_searches" ||
            key === "waiting_approval" ||
            key === "deposit_from_sup" ||
            key === "ended_sort_by_name"
        ) {
          queryParams[key] = 1;

          /*          const filterToPush = this.filtersBarArr;
          const filtered = filterToPush.filter(item => item.key !== key);
          const filter_ = {
            text: key,
            stat: "",
            key: key
          };
          this.filtersBarArr = [...filtered, filter_];*/
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (
            key === "scheduled_calls" ||
            key === "missed_calls" ||
            key === "auto_missed_calls" ||
            key === "coming_calls" ||
            key === "today_calls" ||
            key === "is_new" ||
            key === "selling_group" ||
            key === "leading_new" ||
            key === "loosing_new" ||
            key === "other_new" ||
            key === "active" ||
            key === "is_leading" ||
            key === "online" ||
            key === "nac" ||
            key === "btgp" ||
            key === "auto_removal" ||
            key === "dup_source" ||
            key === "ex_dup_source" ||
            key === "dup_exclude" ||
            key === "merged" ||
            key === "tech" ||
            key === "dup" ||
            key === "reg_dup_total" ||
            key === "na" ||
            key === "na_all" ||
            key === "waiting" ||
            key === "ended" ||
            key === "referral" ||
            key === "transfer" ||
            key === "leads" ||
            key === "deposit" ||
            key === "deposit_clients" ||
            key === "cc_decline_clients" ||
            key === "deposit_to_rem" ||
            key === "deposit_from_cc" ||
            key === "deposit_from_sup"
        ) {
          const filterToPush = this.filtersBarArr;
          const filtered = filterToPush.filter(item => item.key !== key);
          const filter_ = {
            text: key,
            stat: "",
            key: key
          };
          this.filtersBarArr = [...filtered, filter_];
          //  console.log(this.filtersBarArr);
        }
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (key === "deposit_amount") {
          queryParams[key] = vm.filters[key];
        }
        if (key === "last_modified_order") {
          queryParams["sort_order"] = "DESC";
          queryParams["order_by"] = "updated_at";
        }
        if (key === "retired") {
          queryParams[key] = vm.filters.retired;
        }

        if (vm.filters.countryTime.from && vm.filters.countryTime.to) {
          queryParams["country_time_from"] = vm.filters.countryTime.from;
          queryParams["country_time_to"] = vm.filters.countryTime.to;
        }
        if (key === "reschedule_type" && key) {
          queryParams[key] = vm.filters.reschedule_type;
        }
      }

      switch (vm.selectedMainTab) {
        case "total":
          delete queryParams.active;
          break;
        case "clients":
          queryParams.active = 1;
          break;
      }

      //localStorage.setItem("testObject", JSON.stringify(queryParams));
      // if (this.favDataParams !== queryParams) {
      //   this.favDataParams = Object.assign({}, queryParams);
      // }
      return queryParams;
    },

    onChange(event) {
      this.event.endTime = moment(this.event.startTime).add(event.target.value, 'minutes')
        this.startTime = this.event.startTime.format('HH:mm')
            this.endTime  = this.event.endTime.format('HH:mm')
    },
    saveEvent() {
        if(this.scheduledCallReason === null){
            this.scheduledCallCommentError='Please select the reason'
        }else{
            this.event.new = true
            this.$emit("event-created", this.event, this.scheduledCallReason, this.scheduledCallComment);
            this.close();
            this.$emit("call-created", this.event, this.scheduledCallReason, this.scheduledCallComment);

        }

    },
    cancel() {
      this.close();
    },
    close() {
      this.isActive = false;
      // Timeout for the animation complete before destroying
      setTimeout(() => {
        this.$destroy();
        this.$el.remove();
      }, 150);
    }
  },
    watch: {
        scheduledCallReason: function(scheduledCallReason) {
            if(scheduledCallReason !== null){
                this.scheduledCallCommentError = ''
            }
        },}
};
</script>

<style scoped>
.zoom-out-enter-active,
.zoom-out-leave-active {
  transition: opacity 150ms ease-out;
}
.zoom-out-enter-active .animation-content,
.zoom-out-enter-active .animation-content,
.zoom-out-leave-active .animation-content,
.zoom-out-leave-active .animation-content {
  transition: transform 150ms ease-out;
}

.zoom-out-enter,
.zoom-out-leave-active {
  opacity: 0;
}
.zoom-out-enter .animation-content,
.zoom-out-enter .animation-content,
.zoom-out-leave-active .animation-content,
.zoom-out-leave-active .animation-content {
  transform: scale(1.05);
}
    .input-flex-wrapper{
        display: flex;
        align-items: baseline;
        width: 96%;
    }
.input-flex-wrapper div:nth-child(1), .input-flex-wrapper div:nth-child(3){
    flex: 2;
    text-align: center;
}
.input-flex-wrapper div:nth-child(2){
    flex: 1;
    text-align: center;
    font-weight: 600;

}
/*.input-flex-wrapper div:nth-child(4){*/
/*  flex: 1;*/
/*  text-align: center;*/
/*  font-weight: 600;*/

/*}*/
.input-flex-wrapper div:nth-child(1) span, .input-flex-wrapper div:nth-child(3) span,.input-flex-wrapper div:nth-child(4) span{
    padding: 10px;
    background-color: #e6e6e6;
    border: 1px solid lightgrey;
    border-radius: 5px;
    font-weight: 600;
}
    section.form-control{
        height: 40px;
    }
.add-tag-menu-item {
    margin: 6px;
    font-size: 12px !important;
    text-transform: uppercase !important;
}

.add-tag-menu-item:hover {
    background: #e0e0e0;
    cursor: pointer;
}
 .lang-dropdown {
   padding: 5px;
   height: 404px;
   width: 446px;
   overflow-x: hidden;
   list-style: none;
   margin-bottom: 10px;
}
    .sc-reasons{
        padding: 0px 20px;
    }
v-cal-dialog .v-cal-dialog-card__body {
    max-height: 570px !important;

}
.selected-reason {
    background-color: #c1c1c1;
}
span.text-counter-scheduled {
    position: absolute;
    left: 445px;
    top: 666px;
    font-size: 9px;
    color: #d7d7d7;
}
    .help-block{
        color: red;
    }
    .add-reasons{
      cursor: pointer;
      color: red;
      position: relative;
      left: 200px;
    }
.res-it-self{
  cursor: pointer;
  position: relative;
  left: 206px;
  font-size: 16px;
}
.comment-box-scheduled {
  min-width: 444px;
  margin-top: 39px;
}
.for-res{
  cursor: pointer;
  margin-top: 13px;
}
.haj{
  padding-left: 30%;
}
.dot {
  height: 5px;
  width: 5px;
  background-color: red;
  border-radius: 50%;
  /* margin-bottom: 2px; */
  display: inline-block;
  position: absolute;
  top: 159px;
  left: 15px;
}
.for-date {
  top: 27px;
  /* margin-bottom: 7px; */
  position: relative;
  left: 224px;
}

.v-cal-button{
  position: relative;
  top: 20px;
  margin-top: 25px;
}
.forTool{
  position: absolute;
  background: black;
  color: white;
  border: 1px solid black;
  border-radius: 7px;
  right: -34px;
  bottom: 40px;
  font-family: "Montserrat" !important;
}

</style>

